import { createSelector } from 'reselect'
import { featureStateSelector } from './featureStateSelector'

export const campaignsForOptionsSelector = createSelector(
  featureStateSelector,
  state => state.campaignsForOptions || []
)

export default campaignsForOptionsSelector
